import { Country } from "../constants/Constant";

export default class Commons {
  public static ObjectEquals(x: any, y: any) {
    if (x === y) return true;
    if (!(x instanceof Object) || !(y instanceof Object)) return false;
    if (x.constructor !== y.constructor) return false;
    for (var p in x) {
      if (!x.hasOwnProperty(p)) continue;
      if (!y.hasOwnProperty(p)) return false;
      if (x[p] === y[p]) continue;
      if (typeof x[p] !== "object") return false;
      if (!Commons.ObjectEquals(x[p], y[p])) return false;
    }
    for (p in y) if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
    return true;
  }
}

export const zeroPad = (num: number, places: number) =>
  String(num).padStart(places, "0");

export const getAnnouncementStatus = (
  date: Date,
  duration: number
): "active" | "inactive" => {
  var result = new Date(date);
  result.setDate(result.getDate() + duration);
  const start = date.getTime();
  const end = result.getTime();
  const now = new Date().getTime();

  if (now >= start && now <= end) {
    return "active";
  } else {
    return "inactive";
  }
};

export const getAnnouncementStatusV2 = (
  date: Date,
  duration: number
): "active" | "inactive" => {
  var result = new Date(date);
  result.setDate(result.getDate() + duration);
  const start = date.getTime();
  // const end = result.getTime();
  const now = new Date().getTime();

  if (now >= start) {
    return "active";
  } else {
    return "inactive";
  }
};

export const getCollectionNameByCountry = (country: string): string => {
  switch (country) {
    case Country.BOSNIA:
      return "applications-bosnia";
    case Country.SRI_LANKA:
      return "applications-sri_lanka";
    case Country.JAMAICA:
      return "applications-jamaica";
    case Country.INDIA:
      return "applications-india";
    case Country.INDONESIA:
      return "applications-indonesia";
    default:
      return "applications-malaysia";
  }
};

export const getCountryString = (c: Country) => {
  switch (c) {
    case Country.BOSNIA:
      return "Bosnia and Herzegovina";
    case Country.JAMAICA:
      return "Jamaica";
    case Country.MALAYSIA:
      return "Malaysia";
    case Country.INDIA:
      return "India";
    case Country.INDONESIA:
      return "Indonesia";
    default:
      return "Sri Lanka";
  }
};
